import { useQuery } from "@tanstack/react-query";

import { apiClient } from "@/api/client";
import type { paths } from "@/api/schema";

import { promotionKeys } from "./query-keys";

// Aliases over the generated contract (CLAUDE.md rule 4) — never hand-written.
export type PromotionPerformance =
  paths["/v1/promotions/{id}/performance"]["get"]["responses"][200]["content"]["application/json"];
export type BrandRow = NonNullable<PromotionPerformance["by_brand"]>[number];
export type SkuRow = NonNullable<PromotionPerformance["by_sku"]>[number];
export type GiftItem = NonNullable<PromotionPerformance["gifts"]["items"]>[number];

/**
 * GET /v1/promotions/{id}/performance (spec §4). A snapshot, not a live feed:
 * no polling; it re-fetches when the window regains focus (§5.3 — the
 * active→finish transition is picked up that way).
 */
export function usePromotionPerformance(id: string, enabled = true) {
  return useQuery({
    queryKey: promotionKeys.performance(id),
    enabled: enabled && id.length > 0,
    queryFn: async () => {
      const { data, error } = await apiClient.GET("/v1/promotions/{id}/performance", {
        params: { path: { id } },
      });
      /* v8 ignore next -- unreachable: client errorMiddleware throws ApiError on !ok */
      if (error) throw error;
      return data;
    },
    staleTime: 0,
    refetchOnWindowFocus: true,
  });
}
